import styled, { css } from 'styled-components';
import { SUBSECTION_DATA_ATTR } from './constants';
export const SectionWrapper = styled.div `
  background: ${({ theme }) => theme.colors.grey00_1};
  overflow: hidden;
  position: relative;
  border-radius: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;

  ${({ height }) => height &&
    css `
      height: ${height};
    `};

  ${({ theme, inner }) => inner
    ? css `
          border: 1px solid ${theme.colors.grey10_1};
        `
    : theme.shadows.small}
`;
export const ItemsWrapper = styled.div `
  display: flex;
  flex-direction: ${({ horizontal }) => (horizontal ? 'row' : 'column')};
  flex: ${({ hasFixedHeight }) => (hasFixedHeight ? '1' : '0 1 auto')};
  min-height: 0;
  overflow-y: ${({ isExpanded }) => (isExpanded ? 'auto' : 'hidden')};

  ${({ theme, hasTitle }) => hasTitle &&
    css `
      border-top: 1px solid ${theme.colors.grey10_1};
    `}

  & > [${SUBSECTION_DATA_ATTR}] + [${SUBSECTION_DATA_ATTR}] {
    border-top: ${({ horizontal, theme }) => (horizontal ? 'none' : `1px solid ${theme.colors.grey10_1}`)};
    border-left: ${({ horizontal, theme }) => (horizontal ? `1px solid ${theme.colors.grey10_1}` : 'none')};
  }

  ${({ horizontal }) => horizontal &&
    css `
      & > * {
        flex: 1 1 0;
        min-width: 0;
      }
    `}

  ${({ customStyles }) => customStyles}
`;
